module.exports = __webpack_public_path__ + "img/w3_bookmark_dark.c1ad4ce0.png";